// firebase
import { doc, updateDoc } from "firebase/firestore";
import { db } from "config/firebase";

// A ---------------------------------------------------------------------- M

const addPubKeyUrl = async (uid, pubKeyURL) => {
  try {
    const userRef = doc(db, "usercontacts", uid);

    await updateDoc(userRef, {
      pubkeyurl: pubKeyURL,
    });
  } catch (error) {
    console.error("Error in addPubKeyUrl:", error);
  }
};

export default addPubKeyUrl;
